module.exports = __webpack_public_path__ + "img/安防小区管控平台.1f3d3e39.png";